import { toast } from 'react-toastify';
import { Box, Button, ButtonGroup, ClickAwayListener, Container, Stack, TextField, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { SketchPicker } from 'react-color';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { API_URL } from '../../api';
import QuillEditor from '../../utils/QuillEditor';
import Cookies from 'universal-cookie';
import showLoader from 'src/components/loader';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
const cookies = new Cookies();

function UpdateResource() {
  const { id } = useParams();
  const classes = useStyles();
  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [longDescription, setLongDescription] = useState('');
  const [background, setBackground] = useState('');
  const [background2, setBackground2] = useState('');
  const [subjectStatus, setSubjectStatus] = useState("english")


  const [open, setOpen] = useState(false);

  const updateInterest = async (title, description, longDescription, background, subjectStatus) => {
    showLoader(true);
    await axios
      .patch(
        `${API_URL}/api/resources/${id}`,
        { title, description, longDescription, background, subjectStatus },
        {
          headers: {
            Authorization: cookies.get('TOKEN'),
          },
        }
      )
      .then((res) => {
        toast.success(res.data?.message || 'Data updated successfully.');
        navigate('/resource');
      })
      .catch((err) => console.log('err-', err));
    showLoader(false);
  };

  useEffect(() => {
    fetch(`${API_URL}/api/resources/${id}`, {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((result) => {
        setTitle(result?.title);
        setDescription(result?.description);
        setLongDescription(result?.longDescription);
        setBackground(result?.background);
        setBackground2(result?.background);
        setSubjectStatus(result?.subjectStatus);
      })
      .catch((error) => console.log('error', error));
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (title === '') {
      toast.error('Title is required');
      return;
    }

    if (description === '') {
      toast.error('Front description is required');
      return;
    }

    if (longDescription === '') {
      toast.error('Description is required');
      return;
    }
    updateInterest(title, description, longDescription, background, subjectStatus);
  };

  const back = (e) => {
    e.preventDefault();
    navigate('/resource');
  };
  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom style={{ fontFamily: 'Inter', fontWeight: '600' }}>
          New Resource
        </Typography>
      </Stack>
      <Box
        component="form"
        className={classes.form}
        onSubmit={handleSubmit}
        sx={{
          '& > :not(style)': { m: 1, width: '' },
        }}
      >

        <TextField
          className={classes.formFields}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          label="Title"
          type="text"
          margin="normal"
        />
        <div className={classes.textEditor}>
          <p style={{ margin: '5px 0px', fontFamily: 'Inter' }}>Front Description</p>
          {description !== '' ? <QuillEditor value={description} setDesc={setDescription} /> : ''}
        </div>
        <div className={classes.textEditor}>
          <p style={{ margin: '5px 0px', fontFamily: 'Inter' }}>Description</p>
          {longDescription !== '' ? <QuillEditor value={longDescription} setDesc={setLongDescription} /> : ''}
        </div>
        <div className={classes.formFields} style={{ fontFamily: 'Inter' }}>
          Change Color
          {/* {open ?
            <ClickAwayListener onClickAway={() => setOpen(false)}>
              <SketchPicker
                color={background}
                onChangeComplete={color => {
                  setBackground2(color.hex);
                }}
              />
            </ClickAwayListener>
            :
            <Button onClick={() => setOpen(true)}>
              <div style={{ width: '30px', height: '30px', borderRadius: '50%', backgroundColor: background }} />
            </Button>
          } */}
          {open ? (
            <div style={{ display: '-webkit-box' }}>
              <SketchPicker
                color={background2}
                onChangeComplete={(color) => {
                  setBackground2(color.hex);
                }}
              />
              <ButtonGroup
                className={classes.buttons}
                aria-label="outlined primary button group"
                style={{ marginLeft: '10px' }}
              >
                <Button
                  onClick={(e) => {
                    setOpen(false);
                    setBackground2(background);
                  }}
                  style={{ fontFamily: 'Inter', minWidth: '90px' }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={(e) => {
                    setOpen(false);
                    setBackground(background2);
                  }}
                  style={{ fontFamily: 'Inter', minWidth: '90px' }}
                >
                  Save
                </Button>
              </ButtonGroup>
            </div>
          ) : (
            <Button onClick={() => setOpen(true)}>
              <div style={{ width: '30px', height: '30px', borderRadius: '50%', backgroundColor: background2 }} />
            </Button>
          )}
        </div>
        <ButtonGroup className={classes.buttons} aria-label="outlined primary button group">
          <Button onClick={(e) => back(e)} style={{ fontFamily: 'Inter', minWidth: '90px' }}>
            Back
          </Button>
          <Button variant="contained" type="submit" style={{ fontFamily: 'Inter', minWidth: '90px' }}>
            Publish
          </Button>
        </ButtonGroup>
      </Box>
    </Container>
  );
}

export default UpdateResource;

const useStyles = makeStyles((theme) =>
  createStyles({
    form: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    formFields: {
      flexBasis: '45%',
      margin: '10px',
      [theme.breakpoints.down('sm')]: {
        flexBasis: '90%',
      },
    },
    textEditor: {
      flexBasis: '91.5%',
      [theme.breakpoints.down('sm')]: {
        flexBasis: '90%',
      },
    },
    buttons: {
      flexBasis: '91.5%',
      justifyContent: 'flex-end',
    },
  })
);
